// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2hZcM","load8":"Loader_load8__1_H9j"};